/* ============================================================================
   PRESSROOM — PROCESS davranisi (FAZ 2 Parti 1, spec 3.3)
   <pressroom-process> web component. Desktop (>=990px) + no-reduced-motion'da
   GSAP ScrollTrigger ile bolumu PINLER ve track'i yatay (x) scrub eder.
   - Panele girisde HALFTONE MASK "basilir" (.pr-halftone-reveal.is-printed).
   - data-squeegee paneli aktif olunca SQUEEGEE WIPE (.pr-squeegee.is-wiped).
   - Ilerleme cizgisi scrub progress'e bagli dolar.
   - will-change yalniz aktif panelde.

   Kurallar (CLAUDE.md + spec):
   - Vendored GSAP + ScrollTrigger (theme.liquid global). GSAP yoksa: dikey native
     stack (hicbir sey kurma) -> zarif dusum.
   - Pin yalniz matchMedia('(min-width:990px)'). Mobilde pin YOK (jank yok).
   - reduced-motion: pin/scrub kurulmaz; halftone+squeegee statik acik.
   - Hardcoded sure yok; gerekli yerde token PRESSROOM.motion'dan / CSS'ten okunur.
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  customElements.define('pressroom-process', class extends HTMLElement {
    connectedCallback() {
      this._section = this.querySelector('.pr-process');
      this._viewport = this.querySelector('[data-pr-process-viewport]');
      this._track = this.querySelector('[data-pr-process-track]');
      this._fill = this.querySelector('[data-pr-process-fill]');
      this._panels = Array.prototype.slice.call(this.querySelectorAll('[data-pr-process-panel]'));
      if (!this._section || !this._track || this._panels.length === 0) return;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hasGSAP = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';

      // reduced-motion VEYA GSAP yok: statik tam acik (dikey stack zaten CSS taban).
      if (reduced || !hasGSAP) {
        this._printAllStatic();
        return;
      }

      this._gsap = window.gsap;
      this._gsap.registerPlugin(window.ScrollTrigger);

      // Desktop pin yalniz >=990px; mobilde statik dikey stack.
      this._mm = this._gsap.matchMedia();
      this._mm.add('(min-width: 990px)', this._setupPinned.bind(this));
      // <990px: pin yok; panelleri girisde halftone-print et (hafif IO).
      this._mm.add('(max-width: 989px)', this._setupStacked.bind(this));
    }

    disconnectedCallback() {
      if (this._mm) this._mm.revert();
      if (this._io) this._io.disconnect();
    }

    /* reduced-motion / no-GSAP: tum halftone + squeegee statik acik */
    _printAllStatic() {
      this._panels.forEach(function (panel) {
        var media = panel.querySelector('[data-pr-process-media]');
        if (media) {
          media.classList.add('is-printed');
          if (media.classList.contains('pr-squeegee')) media.classList.add('is-wiped');
        }
      });
    }

    /* DESKTOP: pin + yatay scrub */
    _setupPinned() {
      var self = this;
      var gsap = this._gsap;
      var panels = this._panels;
      var track = this._track;
      var viewport = this._viewport;

      viewport.classList.add('is-pinned');

      // Track'in gercek yatay mesafesi (paneller artik <100vw -> bu zaten kisa).
      var getDistance = function () { return track.scrollWidth - window.innerWidth; };
      // Pin (page-scroll) mesafesini gorsel travel'in altina indir: ayni 4 paneli
      // gecmek icin gereken scroll ~%45 azalir -> "daha az scroll, daha akici" his.
      // x her zaman tam getDistance kadar kaydirilir; sadece tetikleyen scroll kisa.
      var SCROLL_SCALE = 0.55;
      var getScrollLen = function () { return Math.round(getDistance() * SCROLL_SCALE); };

      var tween = gsap.to(track, {
        x: function () { return -getDistance(); },
        ease: 'none', // --e-linear (scrub)
        scrollTrigger: {
          trigger: viewport,
          start: 'top top',
          // Pin uzunlugu = kisaltilmis scroll mesafesi (travel'in %55'i).
          end: function () { return '+=' + getScrollLen(); },
          // Numeric scrub: catch-up yumusatma -> ani/zorlayici his gider.
          scrub: 0.6,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onUpdate: function (st) {
            // Ilerleme cizgisi dolumu
            if (self._fill) self._fill.style.width = (st.progress * 100).toFixed(2) + '%';
            // Aktif panel = progress'e gore index
            var idx = Math.round(st.progress * (panels.length - 1));
            self._setActive(idx);
          }
        }
      });
      this._tween = tween;

      // Ilk panel girisde basili
      this._setActive(0);
    }

    /* MOBIL (<990px, no-reduced): dikey stack, panel girisde halftone-print */
    _setupStacked() {
      var self = this;
      if (!('IntersectionObserver' in window)) {
        this._printAllStatic();
        return;
      }
      this._io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self._printPanel(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0.2 });
      this._panels.forEach(function (p) { self._io.observe(p); });
    }

    _printPanel(panel) {
      var media = panel.querySelector('[data-pr-process-media]');
      if (!media) return;
      media.classList.add('is-printed');
      if (media.classList.contains('pr-squeegee')) media.classList.add('is-wiped');
    }

    /* Pinli modda: idx panelini aktiflestir (will-change + halftone/squeegee). */
    _setActive(idx) {
      if (this._activeIdx === idx) return;
      this._activeIdx = idx;
      for (var i = 0; i < this._panels.length; i++) {
        var panel = this._panels[i];
        // Aktif + onceki paneller "basilmis" kalir (geri scroll'da tutarli).
        if (i <= idx) this._printPanel(panel);
        panel.classList.toggle('is-active', i === idx);
      }
    }
  });
})();
